import React from "react";
import { Route, Routes } from "react-router-dom";

import Board from "./board";
import SalesSnapshot from "./snapshot";

export default function Sales() {
  return (
    <Routes>
      <Route path="/" element={<Board />} />
      <Route path="/snapshot" element={<SalesSnapshot />} />
    </Routes>
  );
}
